import { render, staticRenderFns } from "./FlexibleOptimizationWidget.vue?vue&type=template&id=1364a2c2&scoped=true&"
import script from "./FlexibleOptimizationWidget.vue?vue&type=script&lang=js&"
export * from "./FlexibleOptimizationWidget.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1364a2c2",
  null
  
)

export default component.exports